import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxNumberOn', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: require('./numberOn.html'),
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        ngModel: '=',
        boundaryPreviousBookyear: '@',
        boundaryCurrentBookyear: '@',
        endDatePreviousBookyear: '@',
        onChanged: '&',
        todayText: '@',
        clearText: '@',
        numberText: '@',
        cancelText: '@',
        closeOnSelect: '@?',
      },
      controller: [
        '$q',
        function($q) {
          var vm = this;
          vm.$onInit = function() {
            vm.isOpen = false;
            if (typeof vm.ngModel === 'string') {
              vm.ngModel = moment.utc(vm.ngModel.substr(0, 10)).toDate();
            }
            vm.bookyear =
              vm.ngModel && vm.endDatePreviousBookyear && vm.ngModel <= vm.endDatePreviousBookyear
                ? '-1'
                : '0';
            vm.options = {
              initDate: moment.utc().toDate(),
            };
            vm.today = moment.utc().toDate();

            vm.value = vm.ngModel;
            vm.init = false;
            vm.setOptions();
          };
          vm.toggle = function(isOpen) {
            if (isOpen) {
              if (typeof vm.ngModel === 'string') {
                vm.ngModel = moment.utc(vm.ngModel.substr(0, 10)).toDate();
              }
              vm.value = vm.ngModel;
              vm.setOptions();
              vm.init = true;
            }
          };

          vm.setOptions = function(resetValue) {
            vm.options.minDate =
              vm.bookyear < 0
                ? moment.utc(vm.boundaryPreviousBookyear.substr(0, 10)).toDate()
                : moment.utc(vm.boundaryCurrentBookyear.substr(0, 10)).toDate();

            vm.options.maxDate =
              vm.bookyear < 0
                ? moment.utc(vm.endDatePreviousBookyear.substr(0, 10)).toDate()
                : null;
            console.debug(
              'Available dates from %s until %s.',
              vm.options.minDate,
              vm.options.maxDate,
            );
            //Min-max check
            if (vm.value < vm.options.minDate) vm.value = vm.options.minDate;
            if (vm.options.maxDate !== null && vm.value > vm.options.maxDate)
              vm.value = vm.options.maxDate;
            //Select first available date
            if (resetValue) {
              vm.value = vm.options.minDate;
            }
          };

          vm.dateChanged = function() {
            if (vm.closeOnSelect) vm.updateValue(vm.value);
          };
          vm.setToday = function() {
            vm.value = vm.today;
            if (vm.closeOnSelect) vm.updateValue(vm.value);
          };

          vm.updateValue = function(value) {
            vm.isOpen = false;
            if (!vm.onChanged) {
              vm.ngModel = value;
            } else {
              $q.when(
                vm.onChanged({
                  $data: value,
                }),
              ).then(
                result => {
                  if (typeof result === 'string') {
                    //error
                    vm.isOpen = true;
                  } else if (result !== false) {
                    vm.ngModel = value;
                  }
                },
                () => {
                  vm.isOpen = true;
                },
              );
            }
          };

          vm.clearNumber = function() {
            return vm.updateValue(null);
          };

          vm.number = function() {
            return vm.updateValue(vm.value);
          };
        },
      ],
    };
  },
]);
